var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircleArrowLeft = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15.5,
  stroke: "#6D838F"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(8, 8)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 16L9.148 14.8856L3.0624 8.8H16V7.2H3.0624L9.1312 1.1312L8 0C5.0712 2.9288 2.8032 5.1968 0 8C3.1728 11.1728 0.9328 8.9328 8 16Z",
  fill: "#3E5660"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle-arrow-left.ba950b840190c853a81307d0d8c54737.svg";